import { Injectable } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';


@Injectable({
  providedIn: 'root',
})
export class AmplitudeService {
  
  init(key: string): void {
    amplitude.init(key);
  }

  setUserId(userId): void {
    amplitude.setUserId(userId);
  }

  track(eventName: string, props?: Record<string, any> | undefined): void {
    amplitude.track(eventName, props);
  }
}
